import { useAuthContext } from "providers/Auth";
import { FEATURES } from "types/landlord/partner";

/**
 * UI feature flag holding next/previous application navigation back while it
 * ships dark (BSCPF-6998).
 *
 * A `ui_` registry flag (Boom::UiFeatureFlag): the key arrives in the
 * partner's `features` array and is toggled per partner from admin's
 * /ui-feature-flags page. A partner whose features have not loaded counts as
 * OFF.
 *
 * ──────────────────────────────────────────────────────────────────────────
 * REMOVING THE FLAG once the navigation is generally available:
 *
 *  1. Delete this file.
 *  2. `views/applications-id/components/LayoutHeader/components/ApplicationNavigator.tsx`
 *     — drop the flag wrapper (marked `APPLICATION NAVIGATION FLAG`) and
 *     export `Navigator` as `ApplicationNavigator`; drop the flag-off test.
 *  3. `types/landlord/partner.ts` — drop `UI_APPLICATION_NAVIGATION`.
 *  4. Delete the `ui_application_navigation` row in admin's /ui-feature-flags.
 *
 * Passing the list in router state on row open is not gated.
 */
export const useApplicationNavigationEnabled = () => {
  const { partner } = useAuthContext();

  return Boolean(
    partner?.features.includes(FEATURES.UI_APPLICATION_NAVIGATION)
  );
};
